import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {
      snackbarSuccess: true,
      snackbarMsg: 'Successful',
      snackbar: false,
    },
    settingGlobal: {},
    fabPosition: {
      bottom: '16px',
      right: '16px',
    }
  },
  getters: {
    snackbar(state) {
      return state.snackbar;
    },
    settingGlobal(state) {
      return state.settingGlobal;
    },
    fabPosition(state) {
      return state.fabPosition;
    },
  },
  mutations: {
    setSnackbar(state, value) {
      let obj = {
        ...value,
        key: Math.random(),
      };
      state.snackbar = obj;
    },
    setSettingGlobal(state) {
      // Setting static global settings
      const obj = {
        title: 'kalculusPortfolio',
        logo: require('@/assets/logo.png'),
      };
      console.log('Setting global:', obj);
      state.settingGlobal = obj;
    },
    setFabPosition(state, position) {
      state.fabPosition = position;
    }
  },
  actions: {
    initializeSettings({ commit }) {
      commit('setSettingGlobal');
    },
  },
  modules: {},
});
